import { createAction } from 'redux-actions';

import { wrapFetch } from './endpoint';

export const getPopups = createAction('FETCH_POPUPS', async (lan, hotel) => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/${hotel}/popup`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const popups = data.map(popup => ({
		title: popup.title,
		subtitle: popup.subtitle,
		buttonText: popup.btn_text,
		link: popup.link,
		pages: popup.pages,
		image: popup.thumb,
	}));

	return {
		popups,
	};
});

export const getPopupIndex = createAction('FETCH_POPUP_INDEX', async lan => {
	const { status, message, data } = await wrapFetch(`api/v1/web/${lan}/popupIndex`, {
		method: 'GET',
	});

	if (status !== 200) {
		throw new Error(message);
	}

	const popupIndex = data.map(popup => ({
		title: popup.title,
		subtitle: popup.subtitle,
		buttonText: popup.btn_text,
		link: popup.link,
		image: popup.thumb,
	}));

	return { popupIndex };
});

export const closePopup = createAction('CLOSE_POPUP', popupHome => async (dispatch, getState) => {
	await dispatch(getPopups);
	await dispatch(getPopupIndex);
	const { popup: { popups, popupIndex } } = getState();

	if (popupHome === true) {
		if (popupIndex.length > 0) {
			popupIndex.splice(0, 1);
		}
		return { popupIndex };
	}

	if (popups.length > 0) {
		popups.splice(0, 1);
	}

	return { popups };
});



// WEBPACK FOOTER //
// ./src/actions/popup.js